<template>
  <div class="onboarding" v-if="done && !onboardingDone">
    <template v-if="currentStepCounter === Object.keys(steps).length">
      <div class="d-f">
        <h2>You're all set up! ✌️</h2>
        <span class="ml-a">
          <div class="close" @click="$store.dispatch('Theme/onboardingDone')">
            <i class="icon-close-small" />
          </div>
        </span>
      </div>
      <p>
        You got the fundamental parts in place. Take the integration one step further by connecting your shopping cart.
      </p>
      <p>
        <a class="link blue" target="_blank" href="https://www.streamify.io/docs/how-to-connect-streamify-with-your-shopping-cart.html">
          Connect your shopping cart
        </a>
      </p>
    </template>
    <template v-else>
      <div class="d-f">
        <h2>Finish setting up!</h2>
        <span class="ml-a">{{ currentStepCounter + 1 }}/{{ Object.keys(steps).length }}</span>
      </div>
      <ul>
        <li
          v-for="(step, index) in Object.values(steps).sort((a, b) => b.completed - a.completed)"
          :data-completed="step.completed"
          :data-current="step.current"
          :key="index"
          @click="step.current ? $router.push(step.route) : null"
        >
          <i class="icon-check-circle-24" />
          <p>{{ step.text }}</p>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
export default {
  computed: {
    /**
     * Return current done or up to steps
     * @returns {Number}
     */
    currentStepCounter() {
      return Object.values(this.steps).filter(s => s.completed).length;
    },
    /**
     * Return boolean if the onboarding is done or not
     * @returns {Boolean}
     */
    onboardingDone() {
      return this.$store.getters['Theme/onboardingDone'];
    },
  },
  data() {
    return {
      done: false,
      steps: {
        choosePlatform: {
          completed: false,
          text: 'Set up provider and domain',
          current: false,
          route: '/settings/liveshopping',
        },
        playerAppearance: {
          completed: false,
          text: 'Explore player appearance',
          current: false,
          route: '/appearance/lvsp',
        },
        testBroadcast: {
          completed: false,
          text: 'Run a test broadcast',
          current: false,
          route: '/broadcast/schedule',
        },
      },
    };
  },
  async mounted() {
    const onboarding = await this.$store.dispatch('AccountManager/getAccountOnboarding');

    this.steps.choosePlatform = {
      ...this.steps.choosePlatform,
      completed: onboarding.lvs.chose_provider && onboarding.lvs.added_domain,
      current: !onboarding.lvs.chose_provider || !onboarding.lvs.added_domain,
    };

    this.steps.playerAppearance = {
      ...this.steps.playerAppearance,
      completed: onboarding.lvs.used_appearance,
      current: !this.steps.choosePlatform.current && !onboarding.lvs.used_appearance,
    };

    this.steps.testBroadcast = {
      ...this.steps.testBroadcast,
      completed: onboarding.broadcast_gone_live,
      current: !this.steps.playerAppearance.current && !this.steps.choosePlatform.current && !onboarding.broadcast_gone_live,
    };

    this.done = true;
  },
};
</script>

<style lang="scss" scoped>
.onboarding {
  background: #FFF3CB;
  box-shadow: 0 2px 4px 0 rgba(165,179,194,0.20), 0 0 1px 0 rgba(165,179,194,0.50);
  border-radius: 8px;
  padding: 16px;
  position: relative;

  & > p {
    padding: 8px 10px;
    line-height: 24px;
  }

  .close {
    line-height: 0;
    align-items: center;
    background-color: white;
    border-radius: 16px;
    box-shadow: 0 1px 6px 0 rgb(80 153 225 / 20%), 0 1px 1px 0 rgb(80 153 225 / 20%);
    display: flex;
    height: 32px;
    justify-content: center;
    width: 32px;
    color: black;
    position: absolute;
    right: 16px;
    top: 16px;
    font-size: 30px;
    color: #0060FF;

    &:hover {
      cursor: pointer;
    }
  }

  h2 {
    padding-left: 10px;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 24px;
  }

  span {
    font-size: 16px;
    color: #B1A88C;
    line-height: 24px;
  }

  ul {
    margin-top: 6px;
  }

  li {
    align-items: center;
    color: #B1A88C;
    display: flex;
    padding: 8px 10px;

    i {
      font-size: 24px;
      margin-right: 5px;
    }

    p {
      font-size: 14px;
    }

    &[data-completed] {
      color: #00A036;

      p {
        text-decoration: line-through;
      }
    }

    &[data-current] {
      background: #FBFCFF;
      box-shadow: 0 1px 6px 0 rgba(177,168,140,0.20), 0 1px 1px 0 rgba(177,168,140,0.20);
      border-radius: 4px;
      color: #0060FF;
      font-weight: 500;

      &:hover {
        cursor: pointer;
      }
    }
  }

  @media (min-width: 768px) {
    padding: 26px 22px;

    h2 {
      font-size: 20px;
    }

    span {
      font-size: 20px;
    }

    p {
      font-size: 16px;
    }
  }
}
</style>
